import { Controller } from "@hotwired/stimulus"
import {
  Chart,
  BarController,
  BarElement,
  LinearScale,
  CategoryScale,
  Tooltip,
  Legend,
} from "chart.js"

Chart.register(
  BarController, BarElement,
  LinearScale, CategoryScale,
  Tooltip, Legend,
)

export default class extends Controller {
  static values = {
    labels: Array,
    visits: Array,
    visitsLabel: { type: String, default: "Visits" },
  }

  connect() {
    const canvas = this.element.querySelector("canvas") || this.element

    this.chart = new Chart(canvas.getContext("2d"), {
      type: "bar",
      data: {
        labels: this.labelsValue,
        datasets: [
          {
            label: this.visitsLabelValue,
            data: this.visitsValue,
            backgroundColor: "#3b82f6cc",
            borderColor: "#3b82f6",
            borderWidth: 1,
          },
        ],
      },
      options: {
        indexAxis: "y",
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: { mode: "y", intersect: false },
        },
        scales: {
          x: {
            beginAtZero: true,
            title: { display: true, text: this.visitsLabelValue },
            ticks: { stepSize: 1 },
          },
          y: {
            ticks: { autoSkip: false },
          },
        },
      },
    })
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  }
}
